import ResultsGraph from './ResultsGraph'

export default ResultsGraph